import { render } from "./techDemandDetail.vue?vue&type=template&id=887cc3ee&scoped=true"
import script from "./techDemandDetail.vue?vue&type=script&lang=js"
export * from "./techDemandDetail.vue?vue&type=script&lang=js"

import "./techDemandDetail.vue?vue&type=style&index=0&id=887cc3ee&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887cc3ee"]])

export default __exports__